import { createRouter, createWebHistory } from "vue-router";
import Login from "../views/login";
import DiscountMembership from "../views/discount-membership";
import Successful from "../views/successful";
import { storage } from "@/utils/storage";

const routes = [
    {
        path: "/",
        redirect: "/login",
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
    },
    {
        path: "/discount-membership",
        name: "DiscountMembership",
        component: DiscountMembership,
    },
    {
        path: "/successful",
        name: "Successful",
        component: Successful,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});
const originalPush = router.push;
router.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
router.beforeEach((to, from, next) => {
    const dot = storage.getItem('dot');
    const isLogin = !!dot;

    if (to.name !== 'Login' && !isLogin) {
        next({ name: 'Login' });
    } else {
        next();
    }
});

export default router 